export default {
  secretaria_virtual: "{nombreApp} Virtual Secretary's Office",
  secretaria: "Secretariat",
  contenido_principal: "Go to main content",
  menu_inicio: "Home",
  menu_solicitardiploma: "Request your {textoDiploma}",
  menu_diplomas: "{textoDiplomas}",
  menu_salir: "Exit",
  si: "Yes",
  error: "ERROR",
  aceptar: "Accept",
  err_acceso: "Your session has expired",
  err_url: "Enter the system again",
  continuar_preg: "Are you sure to continue?",
  estudiante: "Student",
  bienv_secretariatramites: "You can use the {nombreApp} virtual secretary's office to carry out the formalities for the activities you have carried out.",
  bienv_tramites: " These procedures are personal to each student and will allow them to obtain the necessary data about their activities in {nombreApp}.",
  bienv_puedeshacer: "What can you do?",
  bienv_consultasolicita: "Consult {textoDiplomas} issued",
  soldip_solicite: "Request the {textoDiplomas} of the activities you have successfully completed.",
  soldip_infosolicitud: "Request for certification of an activity will involve the generation and sending of an email containing an electronically signed certificate. In addition, the document can be accessed from your UM Citizen Folder and from our e-administration",
  soldip_pasos: "To request the {textoDiploma} of an activity you must follow these steps:",
  soldip_paso1: "Choose the activity from the list below.",
  soldip_paso2: "Preview your {textoDiploma} and check that the information is correct. If any of the information is incorrect, you should report the incident to our office ({emailApp})",
  soldip_paso3: "If everything is correct, click on the button to issue your {textoDiploma}.",
  soldip_paso4: "Click on the button to generate the {textoDiploma}.", 
  soldip_condiciones: "The list will show the activities that meet the following conditions:",
  soldip_condicion1: "They have not been digitally certified",
  soldip_condicion2: "They have been correctly registered and, if applicable, paid for.",
  soldip_condicion3: "They have been successfully completed.",
  soldip_condicion4: "If something is not correct in the preview, you should contact {nombreApp} to inform them that it is incorrect.",
  soldip_solicita: "Request your {textoDiploma}",
  soldip_puedevisua: "You can view your {textoDiploma} at",
  soldip_comprobar: "The {textoDiploma} is not correct. Do not order the {textoDiploma} until it is displayed correctly.",
  soldip_borrador: "Below is a draft of the {textoDiploma} that will be automatically generated. Check that all the information is correct. In case of any mistakes, please contact our office.",
  soldip_previsualiza: "Generating preview …",
  soldip_dipcorrecto: "Is the {textoDiploma} generated correct?",
  soldip_empty: "There are no activities for which you can request the {textoDiploma}.",
  soldip_dipok: "{textoDiploma} generated correctly",
  soldip_dipgenerado: "{textoDiploma} generated",
  soldip_diperror: "Error generating the {textoDiploma}",
  soldip_previsualizacion: "Preview your {textoDiploma}",
  soldip_actividad: "Activity",
  soldip_previsualizar: "Preview",
  soldip_generar: "Generate",
  soldip_generando: "Generating your {textoDiploma}...",
  soldip_generarconfirma: "The {textoDiploma} of your activity will be generated. This action has no return. Are you sure you want to continue?", 
  soldip_previewerror: "Preview failed, try again later",
  soldip_generarerror: "Generating error, try again later",
  soldip_datosestudanteerror: "Error entering data, try again later",
  diplos_titu_certi: "Your {textoDiplomas}",
  diplos_info: "In this section you can consult all your digital certificates and download an authentic copy.",
  diplos_info2: "You will be able to consult all the {textoDiplomas} generated, as well as to be able to download an authentic copy of each one of them. In the oldest activities, the diplomas were printed, so you must request them from your {nombreApp}, since there is no digital copy of these.",
  diplos_generados: "{textoDiplomas} issued",
  diplos_empty: "There are no {textoDiplomas} generated",
  diplos_actividad: "Activity",
  diplos_fechasol: "Application date",
  diplos_dipgen: "{textoDiploma} downloaded",
  diplos_titucorreo: "Send mail",
  diplos_infocorreo: "An email will be sent to the student with the {textoDiploma} attached.",
  diplos_pregcorreo: "Send mail?",
  diplos_correoenv: "Mail sent",
  diplos_anula: "Cancel {textoDiploma}",
  diplos_dipanulado: "{textoDiploma} cancelled",
  diplos_dipanuladook: "The {textoDiploma} has been cancelled in all systems",
  diplos_anulaerror: "{textoDiploma} could not be cancelled",
  diplos_infoanula: "The student's {textoDiploma} will be cancelled for this activity.",
  diplos_infodip: "The {textoDiploma} was generated by the old system, to obtain it you must contact {nombreApp}",
  diplos_dipdescarga: "The certificate and/or diploma has been downloaded, please check the download window.",
  diplos_dipdescargaerror:"Could not download, please try again later",
  diplos_correook: "The mail has been sent successfully, check your inbox",
  diplos_correoerror: "Could not send the email, please try again later",     
  diplos_descarga: "Download {textoDiploma}",    
  diplos_correo: "Send mail to the student with the {textoDiploma}",    
  diplos_anular: "Cancel the {textoDiploma}",    
  accesibilidad: "Accessibility",
  contactar: "Contact",
  nombre_EEPP: "Own Studies",
  nombre_certic: "CERTIC",
  nombre_unimar: "UNIMAR",
  nombre_default: "Students",
  acceso: "Access the application",
  castellano: "Castellano",
  english: "English",
  diploma_certic: "certificate and/or diploma",
  diploma_default: "certificate and/or diploma",
  diplomas_certic: "certificates and/or diplomas",
  diplomas_default: "certificates and/or diplomas",
  diplomas_certic_cap: "Certificates and/or diplomas",
  diplomas_default_cap: "Certificates and/or diplomas",
warn: "Warn",
  envio_correo_estudiante_info: "Please, tell the student that if they have not received a confirmation email in 24 hours, first check the spam folder in their email account.", 
  error_datos_estudiante: "Correction of student data for  {textoDiploma} generation", 
  error_datos_estudiante_detalle: "Please, details the incorrect data (maximum 4000 characters):", 
  error_datos_estudiante_head: "The certificate and/or diploma has not been generated because you do not have the correct data. You will not be able to request it until the problem has been resolved.", 
  error_datos_estudiante_cambioOK: "The data change has been requested. An email will be sent to the activity manager and {emailEstudiante} with the requested change. {nombreApp} will be in charge of managing it.", 
  error_datos_estudiante_cambioKO: "You have not requested any changes, please preview the {textoDiploma} again and check that the data is correct. If they are not, please detail the data that is incorrect.", 
  error_datos_estudiante_cambio_generado: "Requested change", 
  error_datos_estudiante_cambio_generadoOK: "The change request has been generated successfully", 
  error_datos_estudiante_cambio_error: "Change request failed.", 
  error_datos_estudiante_bloqueo: "You cannot request the {textoDiploma}, it is pending to solve the changes requested by {nombreApp}", 
  error_datos_estudiante_fichero: "If you want, add a file where you justify the change", 
  diploma_papel: "Diploma already generated on paper",
  motivo_anulacion: "Please indicate the reason for cancellation (maximum 100 characters):",
  motivo_anulacion_warn: "Please indicate the reason for cancellation in order to continue.",  
  error_datos_seleccionar_fichero: "Select a file",
  error_datos_estudiante_antes_guardar: "Correction of student data",
  error_datos_estudiante_sin_adjuntos: "You have not attached any file justifying the change. An email will be sent to the {nombreApp} manager to review the errors, are you sure to continue?",   
  error_datos_estudiante_confirma_guardar: "An email will be sent to the {nombreApp} manager to review the errors, are you sure to continue?",
  error_datos_estudiante_cancelar: "Cancel file",
  error_datos_estudiante_continuar: "are you sure to continue?",
};
  
  